<template>
  <div
    class="h-auto lg:h-12 bg-black flex justify-between items-center px-12 w-full flex-wrap lg:flex-nowrap py-6 lg:py-0"
  >
    <h6
      class="text-white text-sm m-0 w-full lg:w-auto mb-2 lg:mb-0 text-center lg:text-left"
    >
      CareerWise © {{ year }}.
      <!--
        <a
        class="text-white text-sm no-underline hover:text-cw-alt"
        href="https://hail.to"
        target="_blank"
        >
        Hail
        </a> 
      -->
      | Images by
      <a
        class="text-white text-sm no-underline hover:text-cw-alt"
        href="https://www.freepik.com/author/upklyak"
        target="_blank"
        >upklyak</a
      >,
      <a
        class="text-white text-sm no-underline hover:text-cw-alt"
        href="https://www.freepik.com/author/katemangostar"
        target="_blank"
        >katemangostar</a
      >, on Freepik
    </h6>
    <div
      class="flex flex-wrap lg:flex-nowrap lg:space-x-4 space-y-2 lg:space-y-0 w-full lg:w-auto mt-6 lg:mt-0"
    >
      <a
        href="mailto:enquiries@careerwise.school"
        class="text-sm font-primary font-bold text-white no-underline m-0 w-full lg:w-auto text-center lg:text-left hover:text-cw-alt"
        >enquiries@careerwise.school</a
      >
      <a
        href="/account"
        class="text-sm font-primary font-bold text-white no-underline cursor-pointer w-full lg:w-auto text-center lg:text-left hover:text-cw-alt"
        >Sign in</a
      >
    </div>
  </div>
</template>

<script>
import { shared } from '../../../js/mixins/shared.js'
import { EventBus } from '../../../js/plugins/event-bus.js'

export default {
  mixins: [shared],

  data() {
    return {
      year: null,
    }
  },

  mounted() {
    const d = new Date()
    let year = d.getFullYear()
    this.$set(this, 'year', year)
  },

  methods: {
    showTermsModal() {
      EventBus.$emit('showModal', 'terms')
    },
  },
}
</script>
